(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["membership-levels"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const escapeHtml = (value) =>
      String(value || "")
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;")
        .replace(/'/g, "&#39;")

    const sections = document.querySelectorAll("[data-membership-carousel]")
    sections.forEach((carousel) => {
      ;(async () => {
      const root = carousel.closest(".membership-levels")
      const viewport = carousel.querySelector("[data-membership-viewport]")
      const track = carousel.querySelector("[data-membership-track]")
      const extrasHost = viewport && viewport.querySelector("[data-membership-extras-host]")
      const prevButton = carousel.querySelector("[data-membership-prev]")
      const nextButton = carousel.querySelector("[data-membership-next]")
      const configEl = root && root.querySelector("[data-membership-tier-config]")

      if (!prevButton || !nextButton || !viewport || !track || !extrasHost) return

      let tierConfig = null
      try {
        tierConfig = configEl ? JSON.parse(configEl.textContent) : null
      } catch (e) {
        tierConfig = null
      }

      const membershipBaseUrl = ((root && root.getAttribute("data-membership-base-url")) || "").replace(/\/$/, "")
      const isMember = tierConfig ? tierConfig.isMember : (root && root.getAttribute("data-member-state")) === "member"
      const shopifyId = Number((root && root.getAttribute("data-shopify-id")) || 0)

      const fetchTierList = async () => {
        if (!membershipBaseUrl) return []
        try {
          const response = await fetch(membershipBaseUrl + "/front/loyalty/membership/tier/list", {
            method: "GET",
            headers: { Accept: "application/json" },
          })
          if (!response.ok) return []
          const payload = await response.json()
          if (!payload || payload.code !== 200 || !Array.isArray(payload.data) || !payload.data.length) {
            return []
          }
          return payload.data
            .slice()
            .sort(
              (a, b) =>
                Number(a.minPoints) - Number(b.minPoints) || Number(a.id) - Number(b.id)
            )
        } catch (e) {
          return []
        }
      }

      const buildMeterSlots = () => {
        let html = ""
        for (let i = 0; i < 24; i += 1) {
          html += '<span class="membership-level-card__meter-slot" data-membership-meter-slot></span>'
        }
        return html
      }

      const buildActionsHtml = (config) => {
        if (config && config.isMember) {
          return (
            '<button type="button" class="membership-level-card__btn membership-level-card__btn--light" data-open-membership-modal="rewards">My Rewards</button>' +
            '<button type="button" class="membership-level-card__btn membership-level-card__btn--dark" data-open-membership-modal="history">Points History</button>'
          )
        }
        const authUrl = escapeHtml((config && config.authUrl) || "#")
        return (
          '<a href="' + authUrl + '" class="membership-level-card__btn membership-level-card__btn--light">Join Free</a>' +
          '<a href="' + authUrl + '" class="membership-level-card__btn membership-level-card__btn--dark">Sign In</a>'
        )
      }

      const buildExtrasHtml = (index, perkPair, config) => {
        const sectionId = (config && config.sectionId) || ""
        const extraBenefits = (config && config.extraBenefits) || []
        const extraBenefitIcons = (config && config.extraBenefitIcons) || []
        const items = extraBenefits
          .map((label, benefitIndex) => {
            const icon = extraBenefitIcons[benefitIndex] || ""
            const strong =
              benefitIndex === 0 && perkPair[0]
                ? "<strong>" + escapeHtml(perkPair[0]) + "</strong>"
                : ""
            return (
              '<li class="membership-level-card__extras-item">' +
              '<span class="membership-level-card__benefit-label">' +
              '<img class="membership-level-card__benefit-icon" src="' +
              escapeHtml(icon) +
              '" alt="" loading="lazy" decoding="async">' +
              "<span>" +
              escapeHtml(label) +
              "</span></span>" +
              strong +
              "</li>"
            )
          })
          .join("")
        return (
          '<div class="membership-level-card__extras" id="membership-extras-' +
          escapeHtml(sectionId) +
          "-" +
          index +
          '" data-membership-extras data-level-index="' +
          index +
          '" hidden><ul class="membership-level-card__extras-grid">' +
          items +
          "</ul></div>"
        )
      }

      let tiersData = []

      const getTierMinPoints = (tier) => {
        if (!tier || tier.minPoints == null) return 0
        const value = Number(tier.minPoints)
        return Number.isFinite(value) ? value : 0
      }

      const getMeterFillRatio = (totalPoints, tierMin) => {
        if (tierMin <= 0) return totalPoints > 0 ? 1 : 0
        return Math.min(1, totalPoints / tierMin)
      }

      const renderMembershipTiers = (tiers, config) => {
        const badgeImages = (config && config.badgeImages) || []
        const badgeAlts = (config && config.badgeAlts) || []
        const perksList = (config && config.perks) || []
        const assets = (config && config.assets) || {}
        const sectionId = (config && config.sectionId) || ""
        const cardsHtml = []
        const extrasHtml = []

        tiers.forEach((tier, index) => {
          const tierId = Number(tier.id)
          if (!tierId) return
          const tierName = tier.tierName || "Member"
          const minPoints = getTierMinPoints(tier)
          const perkPair = perksList[index] || perksList[perksList.length - 1] || ["—", "—"]
          const badgeSrc = badgeImages[index] || badgeImages[badgeImages.length - 1] || ""
          const badgeAlt = badgeAlts[index] || tierName
          const isFirstActive = index === 0

          cardsHtml.push(
            '<article class="membership-level-card membership-level-card--tier-' +
            index +
            (isFirstActive ? " is-active" : "") +
            '" role="listitem" data-level-index="' +
            index +
            '" data-tier-id="' +
            tierId +
            '" data-level-threshold="' +
            minPoints +
            '"' +
            (isFirstActive ? "" : ' aria-hidden="true"') +
            ">" +
            '<h3 class="membership-level-card__level">' +
            escapeHtml(tierName) +
            "</h3>" +
            '<div class="membership-level-card__badge"><img class="membership-level-card__badge-image" src="' +
            escapeHtml(badgeSrc) +
            '" alt="' +
            escapeHtml(badgeAlt) +
            '" loading="lazy" decoding="async"></div>' +
            '<div class="membership-level-card__progress"><span>Points</span><strong data-membership-points-display>0/' +
            escapeHtml(String(Math.round(minPoints))) +
            "</strong></div>" +
            '<div class="membership-level-card__meter" aria-hidden="true">' +
            buildMeterSlots() +
            "</div>" +
            '<div class="membership-level-card__actions">' +
            buildActionsHtml(config) +
            "</div>" +
            '<div class="membership-level-card__benefits-shell"><ul class="membership-level-card__benefits">' +
            '<li><span class="membership-level-card__benefit-label"><img class="membership-level-card__benefit-icon" src="' +
            escapeHtml(assets.perksIcon || "") +
            '" alt="" loading="lazy" decoding="async"><span>Level up perks</span></span><strong>' +
            escapeHtml(perkPair[0]) +
            "</strong></li>" +
            '<li><span class="membership-level-card__benefit-label"><img class="membership-level-card__benefit-icon" src="' +
            escapeHtml(assets.discountsIcon || "") +
            '" alt="" loading="lazy" decoding="async"><span>Level up discounts</span></span><strong>' +
            escapeHtml(perkPair[1]) +
            "</strong></li>" +
            '<li class="membership-level-card__more-row"><button type="button" class="membership-level-card__more" data-membership-more aria-expanded="false" aria-controls="membership-extras-' +
            escapeHtml(sectionId) +
            "-" +
            index +
            '">View all benefits</button></li></ul></div></article>'
          )

          extrasHtml.push(buildExtrasHtml(index, perkPair, config))
        })

        track.innerHTML = cardsHtml.join("")
        track.removeAttribute("aria-busy")
        extrasHost.innerHTML = extrasHtml.join("")
      }

      const tiers = await fetchTierList()
      tiersData = tiers
      renderMembershipTiers(tiers, tierConfig)

      let cards = Array.from(track.querySelectorAll(".membership-level-card"))
      if (!cards.length) return

      let currentIndex = 0

      let initialAlignDone = false
      const numberFormatter = new Intl.NumberFormat("en-US")
      let levelThresholds = cards.map((card) => Number(card.getAttribute("data-level-threshold")) || 0)

      const refreshLevelThresholds = () => {
        levelThresholds = cards.map((card) => Number(card.getAttribute("data-level-threshold")) || 0)
      }

      const formatPoints = (value) => numberFormatter.format(Math.max(0, Math.round(value)))

      const getLevelIndexFromTierId = (tierId) => {
        const id = Number(tierId) || 0
        if (!id) return -1
        return cards.findIndex((card) => Number(card.getAttribute("data-tier-id")) === id)
      }

      const applySummaryData = (data) => {
        if (!data || data.totalPoints == null || data.currentTierId == null) return

        const totalPoints = Number(data.totalPoints) || 0
        const userLevelIndex = getLevelIndexFromTierId(data.currentTierId)
        if (userLevelIndex < 0) return

        refreshLevelThresholds()

        const currentTierMin =
          tiersData[userLevelIndex] != null
            ? getTierMinPoints(tiersData[userLevelIndex])
            : levelThresholds[userLevelIndex] || 0
        cards.forEach((card, idx) => {
          const tierMin = levelThresholds[idx] || 0
          const slots = Array.from(card.querySelectorAll("[data-membership-meter-slot]"))
          const pointsDisplay = card.querySelector("[data-membership-points-display]")
          const isCurrent = idx === userLevelIndex
          let fillRatio = 0

          if (isCurrent) {
            fillRatio = getMeterFillRatio(totalPoints, currentTierMin)
          }

          let filledSlots = 0
          if (isCurrent && slots.length) {
            if (fillRatio >= 1) {
              filledSlots = slots.length
            } else if (fillRatio > 0) {
              filledSlots = Math.max(1, Math.round(fillRatio * slots.length))
            }
          }

          slots.forEach((slot, slotIndex) => {
            slot.classList.toggle("is-filled", slotIndex < filledSlots)
          })

          if (pointsDisplay) {
            if (isCurrent) {
              pointsDisplay.textContent = `${formatPoints(totalPoints)}/${formatPoints(currentTierMin)}`
            } else {
              pointsDisplay.textContent = `0/${formatPoints(tierMin)}`
            }
          }

          card.classList.toggle("is-current-level", isCurrent)
        })

        currentIndex = userLevelIndex
      }

      const loadSummary = async () => {
        if (!membershipBaseUrl || !shopifyId) return
        try {
          const response = await fetch(membershipBaseUrl + "/front/loyalty/summary", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ shopifyId: shopifyId }),
          })
          if (!response.ok) return
          const payload = await response.json()
          const data = payload && payload.data ? payload.data : null
          if (!data) return
          applySummaryData(data)
          render()
        } catch (e) {
          /* ignore */
        }
      }

      if (isMember) {
        loadSummary()
        window.addEventListener("membership:points-updated", () => {
          loadSummary()
        })
      }

      const alignActiveCard = () => {
        const activeCard = cards[currentIndex]
        if (!activeCard) return
        const vw = viewport.clientWidth
        const centerInTrack = activeCard.offsetLeft + activeCard.offsetWidth / 2
        const translateX = Math.round(vw / 2 - centerInTrack)
        if (!initialAlignDone) {
          track.style.transition = "none"
        }
        track.style.transform = "translateX(" + translateX + "px)"
        if (!initialAlignDone) {
          initialAlignDone = true
          track.offsetHeight
          requestAnimationFrame(() => {
            track.style.transition = ""
          })
        }
      }

      const updateNavState = () => {
        const atStart = currentIndex <= 0
        const atEnd = currentIndex >= cards.length - 1
        prevButton.disabled = atStart
        nextButton.disabled = atEnd
      }

      const getExtrasForCard = (card) => {
        const idx = card.getAttribute("data-level-index")
        if (idx == null) return null
        return viewport.querySelector(`[data-membership-extras][data-level-index="${idx}"]`)
      }

      const clearExtrasDock = (extras) => {
        if (!extras) return
        extras.style.top = ""
        extras.style.left = ""
        extras.style.width = ""
        extras.style.right = ""
        extras.style.bottom = ""
      }

      const stripExtrasTimers = (extras) => {
        if (!extras) return
        if (extras._fadeOutTimer) {
          clearTimeout(extras._fadeOutTimer)
          extras._fadeOutTimer = null
        }
        if (extras._extrasTransitionEnd) {
          extras.removeEventListener("transitionend", extras._extrasTransitionEnd)
          extras._extrasTransitionEnd = null
        }
      }

      const killExtrasPanel = (extras) => {
        if (!extras) return
        stripExtrasTimers(extras)
        extras.classList.remove("is-extras-panel-visible")
        extras.hidden = true
        clearExtrasDock(extras)
      }

      const fadeInExtras = (card, extras) => {
        if (!extras) return
        stripExtrasTimers(extras)
        extras.hidden = false
        extras.classList.remove("is-extras-panel-visible")
        requestAnimationFrame(() => {
          alignActiveCard()
          requestAnimationFrame(() => {
            dockExtrasPanel(card)
            requestAnimationFrame(() => {
              extras.classList.add("is-extras-panel-visible")
            })
          })
        })
      }

      const fadeOutExtras = (extras) => {
        if (!extras) return
        stripExtrasTimers(extras)
        let finished = false
        const finish = () => {
          if (finished) return
          finished = true
          stripExtrasTimers(extras)
          extras.hidden = true
          clearExtrasDock(extras)
        }
        if (!extras.classList.contains("is-extras-panel-visible")) {
          finish()
          return
        }
        extras._extrasTransitionEnd = (e) => {
          if (e.target !== extras || e.propertyName !== "opacity") return
          finish()
        }
        extras.addEventListener("transitionend", extras._extrasTransitionEnd)
        extras.classList.remove("is-extras-panel-visible")
        extras._fadeOutTimer = setTimeout(finish, 320)
      }

      const dockExtrasPanel = (card) => {
        const shell = card.querySelector(".membership-level-card__benefits-shell")
        const extras = getExtrasForCard(card)
        if (!shell || !extras) return
        const vr = viewport.getBoundingClientRect()
        const sr = shell.getBoundingClientRect()
        extras.style.top = `${Math.round(sr.bottom - vr.top + 4)}px`
        extras.style.left = `${Math.round(sr.left - vr.left)}px`
        extras.style.width = `${Math.round(sr.width)}px`
        extras.style.right = "auto"
        extras.style.bottom = "auto"
      }

      const repositionOpenExtras = () => {
        const active = cards[currentIndex]
        if (active && active.classList.contains("is-benefits-expanded")) {
          dockExtrasPanel(active)
        }
      }

      const closeBenefitsDrawer = (card) => {
        card.classList.remove("is-benefits-expanded")
        const extras = getExtrasForCard(card)
        const moreButton = card.querySelector("[data-membership-more]")
        killExtrasPanel(extras)
        if (moreButton) {
          moreButton.setAttribute("aria-expanded", "false")
        }
      }

      const render = () => {
        cards.forEach((card, index) => {
          const isActive = index === currentIndex
          card.classList.toggle("is-active", isActive)
          card.setAttribute("aria-hidden", String(!isActive))
          const lockedControls = card.querySelectorAll(".membership-level-card__btn, .membership-level-card__more")
          lockedControls.forEach((control) => {
            if (isActive) {
              control.removeAttribute("tabindex")
              control.removeAttribute("aria-disabled")
            } else {
              control.setAttribute("tabindex", "-1")
              control.setAttribute("aria-disabled", "true")
            }
          })
          if (!isActive) {
            closeBenefitsDrawer(card)
          }
        })
        updateNavState()
        requestAnimationFrame(() => {
          alignActiveCard()
          requestAnimationFrame(() => {
            repositionOpenExtras()
          })
        })
      }

      cards.forEach((card) => {
        const moreButton = card.querySelector("[data-membership-more]")
        if (!moreButton) return
        moreButton.addEventListener("click", () => {
          if (!card.classList.contains("is-active")) return
          const expanded = !card.classList.contains("is-benefits-expanded")
          card.classList.toggle("is-benefits-expanded", expanded)
          const extras = getExtrasForCard(card)
          moreButton.setAttribute("aria-expanded", String(expanded))
          if (expanded && extras) {
            fadeInExtras(card, extras)
          } else if (extras) {
            fadeOutExtras(extras)
          }
        })
      })

      prevButton.addEventListener("click", () => {
        if (currentIndex <= 0) return
        currentIndex -= 1
        render()
      })

      nextButton.addEventListener("click", () => {
        if (currentIndex >= cards.length - 1) return
        currentIndex += 1
        render()
      })

      window.addEventListener("resize", () => {
        alignActiveCard()
        repositionOpenExtras()
      })

      render()
      })()
    })
  })()

  ;(() => {
    const syncMembershipModalScrollLock = () => {
      const anyOpen = document.querySelector('dialog.membership-modal[open]')
      if (anyOpen) {
        document.documentElement.setAttribute('scroll-lock', '')
      } else {
        document.documentElement.removeAttribute('scroll-lock')
      }
    }

    document.querySelectorAll('.membership-levels[data-member-state="member"]').forEach((root) => {
      const dialogs = {
        rewards: root.querySelector('dialog[data-membership-modal="rewards"]'),
        history: root.querySelector('dialog[data-membership-modal="history"]'),
      }
      const rewardsGrid = root.querySelector('[data-membership-rewards-grid]')
      const membershipBaseUrl = (root.getAttribute('data-membership-base-url') || '').replace(/\/$/, '')
      const rewardsShopifyId = Number(root.getAttribute('data-shopify-id') || 0)
      const REWARDS_PAGE_SIZE = 50
      const HISTORY_PAGE_SIZE = 10
      let rewardsLoaded = false
      let historyLoaded = false
      let historyCurrentPage = 1
      const historyTbody = root.querySelector('[data-membership-history-tbody]')
      const historyPagination = root.querySelector('[data-membership-history-pagination]')

      const escapeHtml = (value) =>
        String(value || '')
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;')
          .replace(/'/g, '&#39;')

      const fetchBenefitList = async (benefitCategory) => {
        if (!membershipBaseUrl || !rewardsShopifyId) return []
        try {
          const response = await fetch(membershipBaseUrl + '/front/redeem/redeem/selectPage', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              shopifyId: rewardsShopifyId,
              benefitCategory: benefitCategory,
              pageNum: 1,
              pageSize: REWARDS_PAGE_SIZE,
            }),
          })
          if (!response.ok) return []
          const payload = await response.json()
          if (!payload || payload.code !== 200 || !payload.data || !Array.isArray(payload.data.list)) {
            return []
          }
          return payload.data.list
        } catch (e) {
          return []
        }
      }

      const getRewardCardIcon = (item) => {
        const snapshot = item && item.snapshot ? item.snapshot : {}
        return (snapshot.customerFacingIcon || item.customerFacingIcon || '').trim()
      }

      const createRewardCard = (item, copyIconUrl) => {
        const code = item && item.code ? String(item.code) : ''
        const cardIcon = getRewardCardIcon(item)
        const artHtml = cardIcon
          ? '<div class="membership-reward-card__art">' +
            '<img class="membership-reward-card__coupon-img" src="' +
            escapeHtml(cardIcon) +
            '" alt="" width="120" height="120" loading="lazy" decoding="async">' +
            '</div>'
          : ''

        const article = document.createElement('article')
        article.className = 'membership-reward-card'
        article.innerHTML =
          artHtml +
          '<div class="membership-reward-card__code-block">' +
            '<p class="membership-reward-card__label">Discount Code:</p>' +
            '<div class="membership-reward-card__code-row">' +
              '<code class="membership-reward-card__code">' +
              escapeHtml(code) +
              '</code>' +
              '<button type="button" class="membership-reward-card__icon-copy" data-membership-copy-code="' +
              escapeHtml(code) +
              '" aria-label="Copy discount code">' +
                '<img class="membership-reward-card__copy-img" src="' +
                escapeHtml(copyIconUrl) +
                '" alt="" width="16" height="16" loading="lazy" decoding="async">' +
              '</button>' +
            '</div>' +
          '</div>' +
          '<button type="button" class="membership-reward-card__copy-btn" data-membership-copy-code="' +
          escapeHtml(code) +
          '">Copy</button>'
        return article
      }

      const loadMembershipRewards = async (force) => {
        if (!rewardsGrid) return
        if (!force && rewardsLoaded) return

        const copyIcon = rewardsGrid.getAttribute('data-copy-icon') || ''

        rewardsGrid.innerHTML =
          '<p class="membership-rewards-grid__message" style="grid-column:1/-1;text-align:center;color:#a3a3a3;">Loading...</p>'

        if (!membershipBaseUrl || !rewardsShopifyId) {
          rewardsGrid.innerHTML =
            '<p class="membership-rewards-grid__message" style="grid-column:1/-1;text-align:center;color:#a3a3a3;">No API configured.</p>'
          return
        }

        const [coupons, giftCards] = await Promise.all([
          fetchBenefitList('COUPON'),
          fetchBenefitList('GIFT_CARD'),
        ])

        const items = coupons.concat(giftCards)
        rewardsGrid.innerHTML = ''

        if (!items.length) {
          rewardsGrid.innerHTML =
            '<p class="membership-rewards-grid__message" style="grid-column:1/-1;text-align:center;color:#a3a3a3;">No rewards yet.</p>'
          rewardsLoaded = true
          return
        }

        items.forEach((item) => {
          rewardsGrid.appendChild(createRewardCard(item, copyIcon))
        })
        rewardsLoaded = true
      }

      const formatHistoryPoints = (item) => {
        const positiveTypes = ['EARN', 'REFUND', 'ADMIN_MANUAL_ADD']
        const negativeTypes = ['SPEND', 'ADMIN_MANUAL_SUBTRACT']
        const type = item && item.transaction_type ? String(item.transaction_type) : ''
        const amount = item && item.points_amount != null ? item.points_amount : 0
        const sign = negativeTypes.includes(type) ? '- ' : '+ '
        return sign + amount + ' Points'
      }

      const formatHistoryDate = (value) => {
        if (!value) return '-'
        const date = new Date(value)
        if (Number.isNaN(date.getTime())) return '-'
        return date.toLocaleDateString('en-US', {
          month: 'short',
          day: 'numeric',
          year: 'numeric',
        })
      }

      const renderMembershipHistory = (data) => {
        if (!historyTbody) return
        historyTbody.innerHTML = ''

        if (!data || !data.list || !data.list.length) {
          historyTbody.innerHTML =
            '<tr><td colspan="3" style="text-align:center;color:#a3a3a3;">No records found.</td></tr>'
          if (historyPagination) {
            historyPagination.innerHTML = ''
            historyPagination.hidden = true
          }
          return
        }

        data.list.forEach((item) => {
          const tr = document.createElement('tr')
          tr.innerHTML =
            '<td class="membership-points-table__action">' +
            escapeHtml(item.note || '-') +
            '</td><td class="membership-points-table__points">' +
            escapeHtml(formatHistoryPoints(item)) +
            '</td><td class="membership-points-table__date">' +
            escapeHtml(formatHistoryDate(item.created_at)) +
            '</td>'
          historyTbody.appendChild(tr)
        })

        if (!historyPagination) return
        const totalPages = data.pages || 1
        if (totalPages <= 1) {
          historyPagination.innerHTML = ''
          historyPagination.hidden = true
          return
        }

        historyPagination.hidden = false
        historyPagination.innerHTML = ''
        const current = data.pageNum || 1

        const prev = document.createElement('button')
        prev.type = 'button'
        prev.className = 'membership-history-pagination__btn'
        prev.textContent = '<'
        prev.disabled = current <= 1
        prev.addEventListener('click', () => {
          if (current > 1) loadMembershipHistory(current - 1, true)
        })
        historyPagination.appendChild(prev)

        const start = Math.max(1, current - 2)
        const end = Math.min(totalPages, current + 2)
        for (let i = start; i <= end; i += 1) {
          const btn = document.createElement('button')
          btn.type = 'button'
          btn.className = 'membership-history-pagination__btn' + (i === current ? ' is-active' : '')
          btn.textContent = String(i)
          btn.addEventListener('click', () => {
            if (i !== current) loadMembershipHistory(i, true)
          })
          historyPagination.appendChild(btn)
        }

        const next = document.createElement('button')
        next.type = 'button'
        next.className = 'membership-history-pagination__btn'
        next.textContent = '>'
        next.disabled = current >= totalPages
        next.addEventListener('click', () => {
          if (current < totalPages) loadMembershipHistory(current + 1, true)
        })
        historyPagination.appendChild(next)
      }

      const loadMembershipHistory = async (pageNum, force) => {
        if (!historyTbody) return
        if (!force && historyLoaded && historyCurrentPage === pageNum) return

        historyTbody.innerHTML =
          '<tr><td colspan="3" style="text-align:center;color:#a3a3a3;">Loading...</td></tr>'
        if (historyPagination) {
          historyPagination.innerHTML = ''
          historyPagination.hidden = true
        }

        if (!membershipBaseUrl || !rewardsShopifyId) {
          historyTbody.innerHTML =
            '<tr><td colspan="3" style="text-align:center;color:#a3a3a3;">No API configured.</td></tr>'
          return
        }

        try {
          const response = await fetch(membershipBaseUrl + '/front/points/history/page', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              shopifyId: rewardsShopifyId,
              pageNum: pageNum,
              pageSize: HISTORY_PAGE_SIZE,
            }),
          })
          if (!response.ok) throw new Error('HTTP_' + response.status)
          const payload = await response.json()
          if (!payload || payload.code !== 200 || !payload.data) {
            historyTbody.innerHTML =
              '<tr><td colspan="3" style="text-align:center;color:#ef4444;">Failed to load history.</td></tr>'
            return
          }
          historyCurrentPage = payload.data.pageNum || pageNum
          historyLoaded = true
          renderMembershipHistory(payload.data)
        } catch (e) {
          historyTbody.innerHTML =
            '<tr><td colspan="3" style="text-align:center;color:#ef4444;">Network error.</td></tr>'
        }
      }

      const closeAllExcept = (keep) => {
        Object.values(dialogs).forEach((dlg) => {
          if (dlg && dlg !== keep && dlg.open) dlg.close()
        })
      }

      root.addEventListener('click', (event) => {
        const opener = event.target.closest('[data-open-membership-modal]')
        if (opener) {
          const key = opener.getAttribute('data-open-membership-modal')
          const dlg = dialogs[key]
          if (dlg && typeof dlg.showModal === 'function') {
            closeAllExcept(dlg)
            try {
              dlg.showModal()
              syncMembershipModalScrollLock()
              if (key === 'rewards') {
                loadMembershipRewards(false)
              } else if (key === 'history') {
                loadMembershipHistory(1, true)
              }
            } catch (e) {
              /* ignore */
            }
          }
          return
        }

        const closer = event.target.closest('[data-membership-modal-close]')
        if (closer) {
          const dlg = closer.closest('dialog')
          if (dlg && dlg.open) dlg.close()
          return
        }

        const copyBtn = event.target.closest('[data-membership-copy-code]')
        if (copyBtn) {
          const text = copyBtn.getAttribute('data-membership-copy-code') || ''
          if (text && navigator.clipboard && navigator.clipboard.writeText) {
            navigator.clipboard.writeText(text).catch(() => {})
          }
        }
      })

      Object.values(dialogs).forEach((dlg) => {
        if (!dlg) return
        dlg.addEventListener('close', syncMembershipModalScrollLock)
        dlg.addEventListener('click', (event) => {
          if (event.target === dlg) dlg.close()
        })
      })

      window.addEventListener('membership:points-updated', () => {
        rewardsLoaded = false
        historyLoaded = false
        if (dialogs.rewards && dialogs.rewards.open) {
          loadMembershipRewards(true)
        }
        if (dialogs.history && dialogs.history.open) {
          loadMembershipHistory(historyCurrentPage, true)
        }
      })
    })
  })()

  } catch(e) { console.error(e); }
})();
})();
